import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { RootState } from 'reducers/rootReducer'
import { sendContactMessage } from 'actions/landing.action'
import IContact from 'models/IContact'

export interface ContactProps {}

export const useContact = (props: ContactProps) => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')

  const dispatch = useAppDispatch()

  const isLoading: boolean = useSelector(
    (state: RootState) => state.landing.isLoading
  )
  const isSendContactMessageSuccess: boolean = useSelector(
    (state: RootState) => state.landing.isSendContactMessageSuccess
  )

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    const messageBody: IContact = {
      name,
      email,
      subject,
      message,
    }

    dispatch(sendContactMessage(messageBody))
  }

  useEffect(() => {
    if (isSendContactMessageSuccess) {
      setName('')
      setEmail('')
      setSubject('')
      setMessage('')
    }
  }, [isSendContactMessageSuccess])

  return {
    ...props,
    name,
    email,
    subject,
    message,
    isLoading,
    isSendContactMessageSuccess,
    setName,
    setEmail,
    setSubject,
    setMessage,
    onSubmit,
  }
}
